export default "__VITE_ASSET__8fb70d44__"